import { spacer24, spacer12, Text } from '@spotify-internal/encore-web/core';
import React from 'react';
import styled from 'styled-components';
import { TextLink } from '../../../../../LinkV2';
import { trackCat } from '../../../../constants';
const GalleryLinkListSection = styled.section `
  & nav {
    list-style: none;
    padding: 0;
    margin: 0;
    margin-top: ${spacer24};
    & li {
      margin-bottom: ${spacer12};
      & a {
        padding: 0;
      }
    }
  }
`;
const EyebrowLabel = styled(Text).attrs({
    variant: 'bodySmall',
    semanticColor: 'textSubdued',
}) ``;
export const GalleryLinkList = ({ eyebrow, links, size, }) => {
    return (React.createElement(GalleryLinkListSection, null,
        React.createElement(EyebrowLabel, null, eyebrow),
        React.createElement("nav", null, links.map((galleryLink, index) => (React.createElement("li", { key: index + 1 },
            React.createElement(TextLink, Object.assign({}, galleryLink.link, { size: size || 'medium', trackingCategory: trackCat }))))))));
};
//# sourceMappingURL=index.js.map